import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './Start.css';

function BusinessNameInput() {
    const navigate = useNavigate();
    const [businessName, setBusinessName] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const token = localStorage.getItem('access_token');

    useEffect(() => {
        if (!token) {
            navigate('/');
        }

        const savedName = localStorage.getItem('business_name');
        if (savedName) {
            setBusinessName(savedName);
        }
    }, [token, navigate]);

    const handleNext = () => {
        if (!businessName.trim()) {
            setErrorMessage('業務名を入力してください');
            return;
        }
        setErrorMessage('');

        // 保存到 localStorage
        localStorage.setItem('business_name', businessName);

        // 跳转到问卷页
        navigate('/survey');
    };

    return (
        <div className="app-container">
            <Helmet>
                <link
                    href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&display=swap"
                    rel="stylesheet"
                />
            </Helmet>
            <header className="header">
                <div className="logo">
                    <h1></h1>
                    <p className="subtitle" style={{ marginBottom: '10px' }}></p>
                </div>
            </header>
            <main className="main-content">
                <section id="business-name-screen" className="screen active">
                    <div className="card" style={{ marginTop: '100px' }}>
                        <h2 className="section-title">業務名の入力</h2>

                        <div className="info-text">
                            <p>自動化の可能性を評価するために、まずは対象となる業務を特定しましょう。</p>
                            <p>この業務名は、以降のシミュレーションで質問内容や分析結果に反映されます。</p>
                            <p>実際に自動化を検討したい業務、もしくは改善したいと感じている業務名を入力してください。</p>
                        </div>

                        {errorMessage && (
                            <div className="error-container">
                                <p className="error">{errorMessage}</p>
                            </div>
                        )}

                        <div className="form-container">
                            <div className="form-group">
                                <label htmlFor="business-name">業務名</label>
                                <input
                                    type="text"
                                    id="business-name"
                                    className="form-input"
                                    placeholder="例: 見積作成、発注処理、契約書確認など"
                                    value={businessName}
                                    onChange={(e) => setBusinessName(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="button-container" style={{ justifyContent: 'flex-end' }}>
                            <button
                                id="next-button"
                                className="btn btn-primary"
                                onClick={handleNext}
                            >
                                次へ
                            </button>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}

export default BusinessNameInput;
